import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import Layout from 'components/Layout'
import ScreenShell from 'components/ScreenShell/ScreenShell'
import RenderSubRoutes from 'components/RenderSubRoutes'
import SidebarDetailTemplatesAccordian from 'components/Sidebars/SidebarDetailTemplatesAccordian'
import getTemplateRoutes from './getTemplateRoutes'
import routes from 'constants/routes'

const TemplateSiteDetail_Show = () => {
	const params = useParams()
	const currentRoute = useLocation()

	const pathArray = currentRoute.pathname.split('/')
	const isPartnerPage = pathArray[pathArray.length - 1] === 'partners'

	const { id } = params
	const subRoutes = getTemplateRoutes(id)

	return (
		<ScreenShell>
		<Layout>
			<Layout.SecondaryNav
				links={subRoutes}
				backLink={{ title: 'Templates', link: routes.TEMPLATES }}
				sourceName="Templates Home"
			/>
			<Layout.Page>
				<Layout.Sidebar>
					<SidebarDetailTemplatesAccordian />
				</Layout.Sidebar>
				<Layout.Body>
					<RenderSubRoutes routes={subRoutes} />
				</Layout.Body>
			</Layout.Page>
		</Layout>
		</ScreenShell>
	)
}

export default TemplateSiteDetail_Show
